import React from "react";

const TermsOfUse = () => {
  return (
    <>
      <div className="container my-5">
        <h1 className="text-center mb-4">Terms & Conditions</h1>
        <div className="mb-5">
          <h2>1. Introduction</h2>
          <p>
            These Terms of Use along with Terms of Service (collectively, the
            “User Agreement”) constitute a legally binding agreement made
            between you, whether personally or on behalf of an entity
            (“You/User”) and Bigsmile Holidays Pvt Ltd (“Bigsmile”), a travel
            technology company incorporated and existing in India in accordance
            with the Companies Act, 1956, concerning your access to and use of
            the “Bigsmileholidays.com” website as well as mobile application
            related, linked, or otherwise connected thereto and/or any other
            technological way of access by you (collectively, the “Site”).
          </p>
          <p>
            Whereas, User/customer includes any person who utilizes the services
            of Bigsmile, which includes services for e-booking/ticketing of
            hotels, flights, bus, rails, and/or group booking for flights and
            hotels through its websites or mobile applications or any other mode
            of technological access to Bigsmile.
          </p>
          <p>
            Both User and Bigsmile are individually referred to as a party and
            collectively referred to as parties to the present User Agreement.
          </p>
        </div>
        <div className="mb-5">
          <h2>2. Eligibility of Use</h2>
          <p>
            The User must be at least 18 years of age and must possess the legal
            authority to enter into an agreement to become a User and use the
            services of Bigsmile. If you are a minor or below the age of 18
            years, you shall not register as a User of the website and shall not
            transact on or use the website.
          </p>
          <p>
            You represent and warrant that all registration information you
            submit will be true, accurate, current, and complete. You will
            maintain the accuracy of such information and promptly update
            registration information as necessary. You have the legal capacity
            and agree to comply with the User Agreement. You will not access the
            Site through automated or non-human means, whether through bot,
            script, or otherwise. You will also not use the Site for any illegal
            or unauthorized purpose. Your use of the Site will not violate any
            applicable law or regulation.
          </p>
        </div>
        <div className="mb-5">
          <h2>3. Intellectual Property Rights</h2>
          <p>
            Unless otherwise indicated, the Site is our proprietary property,
            and all source code, databases, functionality, software, website
            designs, audio, video, text, photographs, and graphics on the Site
            (Content) and the trademarks, service marks, and logos therein are
            owned or controlled by Bigsmile or licensed to Bigsmile, and are
            protected by copyright and trademark laws and various other
            intellectual property rights and unfair competition laws of India,
            foreign jurisdictions, and international conventions.
          </p>
          <p>
            The Content and the Marks are provided on the Site “AS IS” for your
            information and personal use only. Except as expressly provided in
            these Terms of Use, no part of the Site and no Content or Marks may
            be copied, reproduced, aggregated, republished, uploaded, posted,
            publicly displayed, encoded, translated, transmitted, distributed,
            sold, licensed, or otherwise exploited for any commercial purpose
            whatsoever, without our express prior written permission.
          </p>
          <p>
            You are granted a limited license to access and use the Site and to
            download or print a copy of any portion of the Content to which you
            have properly gained access solely for your personal, non-commercial
            use. We reserve all rights not expressly granted to you in and to
            the Site, the Content, and the Marks.
          </p>
        </div>
        <div className="mb-5">
          <h2>4. Bigsmile Website</h2>
          <p>
            The Website is meant to be used by bona fide User(s) for lawful use.
            Users shall not distribute, exchange, modify, sell, or transmit
            anything from the Website, including but not limited to any text,
            images, audio, and video, for any business, commercial, or public
            purpose. The User Agreement grants a limited, non-exclusive,
            non-transferable right to use this Website as expressly permitted in
            this User Agreement.
          </p>
          <p>
            The User agrees not to interrupt or attempt to interrupt the
            operation of the Website in any manner whatsoever. Access to certain
            features of the Website may only be available to registered User(s).
            The process of registration may require the User to answer certain
            questions or provide certain information that may or may not be
            personal in nature. Some such fields may be mandatory or optional.
            User represents and warrants that all information supplied to
            Bigsmile is true and accurate.
          </p>
          <p>
            Bigsmile reserves the right, in its sole discretion, to terminate
            access to the Website and the services offered or any portion
            thereof at any time, without notice, for general maintenance or any
            other reason whatsoever. Bigsmile will always make its best
            endeavors to ensure that the content on its websites or other sales
            channels is free of any virus or other malware. However, any data or
            information downloaded or otherwise obtained through the use of the
            Website or any other sales channel is done entirely at the User’s
            own discretion and risk, and they will be solely responsible for any
            damage to their computer systems or loss of data that may result
            from the download of such data or information.
          </p>
          <p>
            Bigsmile reserves the right to periodically make improvements or
            changes in its Website at any time without prior notice to the User.
            User(s) are requested to report any content on the Website which is
            deemed to be unlawful, objectionable, libelous, defamatory, obscene,
            harassing, invasive to privacy, abusive, fraudulent, against any
            religious beliefs, spam, or violative of any applicable law to
            Bigsmile on its registered email address. On receiving such report,
            Bigsmile reserves the right to investigate and/or take such action
            as the Company may deem appropriate.
          </p>
        </div>
        <div className="mb-5">
          <h2>5. Site Management</h2>
          <p>Bigsmile reserves the right, but not the obligation, to:</p>
          <ul>
            <li>Monitor the Site for violations of these Terms of Use;</li>
            <li>
              Take appropriate legal action against anyone who, in our sole
              discretion, violates the law or these Terms of Use, including
              without limitation, reporting such User to law enforcement
              authorities;
            </li>
            <li>
              In our sole discretion and without limitation, refuse, restrict
              access to, limit the availability of, or disable (to the extent
              technologically feasible) any of your Contributions or any portion
              thereof;
            </li>
            <li>
              Otherwise manage the Site in a manner designed to protect our
              rights and property and to facilitate the proper functioning of
              the Site.
            </li>
          </ul>
        </div>
        <div className="mb-5">
          <h2>6. Prohibited Activities by User/Customer</h2>
          <p>
            You may not access or use the Site for any purpose other than that
            for which we make the Site available. The Site may not be used in
            connection with any commercial endeavors except those that are
            specifically endorsed or approved by us. As a User of the Site, you
            agree not to:
          </p>
          <ul>
            <li>
              Systematically retrieve data or other content from the Site to
              create or compile, directly or indirectly, a collection,
              compilation, database, or directory without written permission
              from us;
            </li>
            <li>
              Make any unauthorized use of the Site, including collecting
              usernames and/or email addresses of Users by electronic or other
              means for the purpose of sending unsolicited email, or creating
              User accounts by automated means or under false pretenses;
            </li>
            <li>
              Use the Site to advertise or offer to sell goods and services;
            </li>
            <li>
              Circumvent, disable, or otherwise interfere with security-related
              features of the Site;
            </li>
            <li>Engage in unauthorized framing of or linking to the Site;</li>
            <li>
              Trick, defraud, or mislead us and other Users, especially in any
              attempt to learn sensitive account information such as User
              passwords;
            </li>
            <li>
              Interfere with, disrupt, or create an undue burden on the Site or
              the networks or services connected to the Site;
            </li>
            <li>
              Attempt to impersonate another User or person or use the username
              of another User;
            </li>
            <li>Sell or otherwise transfer your profile;</li>
            <li>
              Use any information obtained from the Site to harass, abuse, or
              harm another person;
            </li>
            <li>
              Use the Site as part of any effort to compete with us or otherwise
              use the Site and/or the Content for any revenue-generating
              endeavor or commercial enterprise;
            </li>
            <li>
              Decipher, decompile, disassemble, or reverse engineer any of the
              software comprising or in any way making up a part of the Site;
            </li>
            <li>
              Attempt to bypass any measures of the Site designed to prevent or
              restrict access to the Site, or any portion of the Site;
            </li>
            <li>
              Harass, annoy, intimidate, or threaten any of our employees or
              agents engaged in providing any portion of the Site to you;
            </li>
            <li>
              Delete the copyright or other proprietary rights notice from any
              Content;
            </li>
            <li>
              Copy or adapt the Site’s software, including but not limited to
              Flash, PHP, HTML, JavaScript, or other code;
            </li>
            <li>
              Except as may be the result of standard search engine or Internet
              browser usage, use, launch, develop, or distribute any automated
              system, including without limitation, any spider, robot, cheat
              utility, scraper, or offline reader that accesses the Site;
            </li>
            <li>
              Upload or transmit (or attempt to upload or to transmit) viruses,
              Trojan horses, or other material that interferes with any party’s
              uninterrupted use and enjoyment of the Site;
            </li>
            <li>
              Disparage, tarnish, or otherwise harm, in our opinion, us and/or
              the Site;
            </li>
            <li>
              Use the Site in a manner inconsistent with any applicable laws or
              regulations.
            </li>
          </ul>
        </div>
        <div className="mb-5">
          <h2>7. Limitations of Bigsmile Liabilities</h2>
          <p>
            Bigsmile always acts as a facilitator by connecting the User with
            the respective service providers like airlines, hotels, railways,
            buses, etc. (hereinafter referred to as “Service Providers”).
            Bigsmile’s liability is limited to providing the User with confirmed
            bookings as selected by the User. Any issues or concerns faced by
            the User at the time of availing any service shall be the sole
            responsibility of the Service Provider.
          </p>
          <p>
            Bigsmile shall have no liability with respect to the acts,
            omissions, errors, representations, warranties, or negligence on the
            part of any Service Provider. Unless explicitly committed by
            Bigsmile as part of any product or service, Bigsmile has no
            liability for the standards of services as provided by the
            respective Service Providers. Bigsmile provides no guarantee with
            regard to their quality or fitness for their performance as
            represented. Bigsmile does not guarantee the ability of any services
            as listed by the Service Provider.
          </p>
          <p>
            By making a booking, the User understands that Bigsmile provides a
            technology platform for booking of services and products, and the
            ultimate liability rests on the respective Service Provider and not
            Bigsmile. The ultimate contract of services is between the User and
            the Service Provider. The User further understands that the
            information displayed on the website with respect to any services is
            displayed as furnished by the Service Provider only. Bigsmile cannot
            be held liable if the information provided by the Service Provider
            is found to be inaccurate, inadequate, obsolete, or in contravention
            of any laws, rules, regulations, or directions in force.
          </p>
        </div>
        <div className="mb-5">
          <h2>8. Account-Related Information</h2>
          <p>
            The User shall be solely responsible for maintaining the
            confidentiality of their account and passwords, as well as all
            activities carried out by the User through the said account. The
            User is bound by any illegal activities carried out through their
            account and is also duty-bound to notify Bigsmile immediately in
            writing of any unauthorized/illegal use of their password or account
            or any other breach of security.
          </p>
          <p>
            It is hereby informed that Bigsmile shall not be liable for any loss
            that may be incurred by the User as a result of unauthorized use of
            their account, either with or without the User’s knowledge. Bigsmile
            shall keep all necessary data of Users relating to personal
            information entered on the website, as well as data relating to all
            banking accounts, credit/debit cards, etc., in a secured and
            encrypted form. Bigsmile is at liberty to verify various information
            of Users, which includes details of bank accounts and/or credit
            scores as and when required.
          </p>
        </div>
        <div className="mb-5">
          <h2>9. Fees and Payment</h2>
          <p>
            Bigsmile may charge certain fees as service charges in addition to
            the actual cost of bookings charged by Service Providers. In cases
            where the User fails to deposit the charge or booking charges of
            Service Providers, Bigsmile is at liberty to cancel the booking
            without informing the User.
          </p>
          <p>
            In cases of short charging of the booking amount, taxes, convenience
            fees, expenses, service charges, etc., due to any technical error or
            other reason, Bigsmile reserves the right to deduct, charge, or
            claim the balance amount from the User, and the User shall pay such
            balance amount to Bigsmile.
          </p>
          <p>
            The User agrees and confirms that all payments shall only be made to
            the bank account of Bigsmile. If the User, by mistake or knowingly,
            transfers any amount against any booking to any bank account other
            than that held by Bigsmile or to any personal account of any person,
            Bigsmile shall not be held liable for the same, and the User shall
            have no right to recover from Bigsmile any amount transferred to any
            third party.
          </p>
          <p>
            It is also the duty of the User not to share any password, OTP, CVV,
            or any other confidential information with any person, including
            agents, employees, licensees, or any person related to Bigsmile.
          </p>
          <p>
            Bigsmile will send booking information for flights, rails, hotels,
            or any other services obtained by the Users from the website of
            Bigsmile via SMS, internet-based messaging applications (e.g.,
            WhatsApp), or any other alternative communication details provided
            by the User at the time of booking. Bigsmile may also inform Users
            about pending or failed bookings to understand the User’s
            preferences and assist with the same. It is agreed and confirmed by
            the User that they have given unconditional consent for such
            communications to Bigsmile.
          </p>
        </div>
        <div className="mb-5">
          <h2>10. User Applications for Insurance and Obtaining Visas</h2>
          <p>
            In no case shall Bigsmile accept any claims for any specific service
            or deliverables unless explicitly provided by Bigsmile in writing to
            the User. It is also agreed by the User that all international
            bookings made through Bigsmile are subject to the requirements of
            visas, including but not limited to transit visas and other modes of
            visas required for the countries the User intends to visit or
            transit through. Bigsmile is not responsible for any issues,
            including inability to travel, arising out of such visa requirements
            and is also not liable to refund any amount to the User for being
            unable to utilize the booking.
          </p>
        </div>
        <div className="mb-5">
          <h2>11. Force Majeure</h2>
          <p>
            For the purpose of this Agreement, an “Event of Force Majeure” means
            any circumstance not within the reasonable control of the Party
            affected, but only if and to the extent that (i) such circumstance,
            despite the exercise of reasonable diligence and the observance of
            Good Utility Practice, cannot be, or be caused to be, prevented,
            avoided, or removed by such Party, and (ii) such circumstance
            materially and adversely affects the ability of the Party to perform
            its obligations under this Agreement, and such Party has taken all
            reasonable precautions, due care, and reasonable alternative
            measures to avoid the effect of such event on the Party’s ability to
            perform its obligations under this Agreement and to mitigate the
            consequences thereof.
          </p>
          <p>
            Instances of Force Majeure shall include, but not be limited to:
          </p>
          <ul>
            <li>
              Fire, chemical or radioactive contamination, ionising radiation,
              earthquakes, lightning, cyclones, hurricanes, floods, droughts, or
              such other extreme weather or environmental conditions,
              unanticipated geological or ground conditions, epidemic, famine,
              plague, or other natural calamities and acts of God;
            </li>
            <li>
              Explosion, accident, breakage of a plant or equipment, structural
              collapse, or chemical contamination (other than resulting from an
              act of war, terrorism, or sabotage), caused by a person not being
              the affected Party or one of its contractors or subcontractors or
              any of their respective employees or agents;
            </li>
            <li>
              To the extent that they do not involve India or take place outside
              of India, acts of war (whether declared or undeclared), invasion,
              acts of terrorists, blockade, embargo, riot, public disorder,
              violent demonstrations, insurrection, rebellion, civil commotion,
              and sabotage;
            </li>
            <li>
              Strikes, lockouts, work stoppage, labor disputes, and such other
              industrial action by workers related to or in response to the
              terms and conditions of employment of those workers or others with
              whom they are affiliated, save when such event is directly related
              to, or in direct response to, any employment policy or practice
              (with respect to wages or otherwise) of the party whose workers
              resort to such action;
            </li>
            <li>
              To the extent they take place in India, acts of terrorists,
              blockade, embargo, riot, public disorder, violent demonstrations,
              insurrection, rebellion, civil commotion, and sabotage;
            </li>
            <li>
              To the extent that they are politically motivated, strikes,
              lockouts, work stoppages, labor disputes, or such other industrial
              action by workers, save in relation to the Concessionaire, when
              such event is directly related to, or in direct response to, any
              employment policy or practice (with respect to wages or
              otherwise).
            </li>
          </ul>
        </div>
        <div className="mb-5">
          <h2>12. Refund Policy</h2>
          <p>
            Bigsmile’s service charges are non-refundable in all cases. For any
            other refund policies, please contact Bigsmile directly to confirm
            if additional policies apply, as they may differ from other
            websites.
          </p>
          <p className="fst-italic text-muted">
            Note: The refund policy specifics beyond the non-refunded service
            charge require confirmation from Bigsmile management.
          </p>
        </div>
        <div className="mb-5">
          <h2>13. Jurisdiction and Dispute Resolution</h2>
          <p>
            This User Agreement shall be governed by and construed in accordance
            with the laws of India. The jurisdiction for any disputes arising
            out of or in connection with this Agreement shall be determined
            based on confirmation from Bigsmile management regarding whether
            India-wide jurisdiction or a specific state in India is preferred.
          </p>
          <p>
            Regarding dispute resolution, Bigsmile is yet to confirm whether an
            Arbitration Clause should be incorporated or if disputes should be
            subject to the courts of law applicable to the chosen jurisdiction.
            Users are advised to contact Bigsmile for the latest information on
            dispute resolution mechanisms.
          </p>
          <p className="fst-italic text-muted">
            Note: Jurisdiction and dispute resolution details require
            confirmation from Bigsmile management.
          </p>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
